<footer class="checkout-footer">
  <div class="left-content">
    <span>{{ 'APP.CART_TO_BE_PAID' | translate }}</span>
    <strong>{{ total | currency:'USD':'symbol':'1.0-0' }}</strong>
  </div>

  <button type="button" (click)="checkout.emit()">
    <span>{{ 'APP.CART_CHECKOUT' | translate }}</span>
    <i class="pi pi-arrow-right"></i>
  </button>
</footer>